import { useState } from "react";
import { Card } from "react-bootstrap";
import { Table, Button, Select, Flex, Pagination } from 'antd';

export function AudienceContent({data,columns,loading}){
  const [selectedRowKey, setSelectedRowKey] = useState(null);

  const handleRowClick = (record) => {
    setSelectedRowKey(record.key);
  };
  
  const rowClassName = (record) => {
    return record.key === selectedRowKey ? 'selected-row' : '';
  };

  return (
    <Card className="mt-4" border='light'>
      <Card.Body>
        <Table 
          columns={columns} 
          dataSource={data} 
          rowClassName={rowClassName}           
          loading={loading}           
          onRow={(record) => ({
            onClick: () => handleRowClick(record), 
          })}       
          size="middle"             
          pagination={{ pageSize: 8 }} 
        />
      </Card.Body>
    </Card>        
  )
}